// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__KDxOb","buttonWrapper":"Footer_buttonWrapper__a1Tyu"};